import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const BarChartIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M6.75 12V20.25" stroke="currentColor" strokeWidth="1.5" /><path d="M12 3.75V20.25" stroke="currentColor" strokeWidth="1.5" /><path d="M17.25 8.25V20.25" stroke="currentColor" strokeWidth="1.5" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BarChartIcon;